<template>
  <div class="flex justify-center items-center md:mt-16">
    <form
      class="w-full max-w-xl p-6 md:p-16 md:shadow-xl md:border md:dark:border-gray-700 md:rounded md:bg-white md:dark:bg-gray-800 transition-colors duration-200"
      @submit.prevent="signInWithEmailAndPassword()"
    >
      <h2 class="font-bold text-2xl text-gray-900 dark:text-gray-100 mb-10">
        Sign in to your account
      </h2>

      <div class="rounded-md shadow-sm md:px-2">
        <div>
          <input
            v-model="email"
            aria-label="Email address"
            name="email"
            type="email"
            required
            class="form-input rounded-b-none"
            placeholder="Email address"
            autocomplete="username"
          />
        </div>
        <div class="-mt-px">
          <input
            v-model="password"
            aria-label="Password"
            name="password"
            type="password"
            required
            class="form-input rounded-t-none"
            placeholder="Password"
            autocomplete="current-password"
          />
        </div>
      </div>

      <div class="my-6 px-3 flex items-center justify-between">
        <div class="flex items-center">
          <input
            id="remember_me"
            type="checkbox"
            class="form-checkbox h-4 w-4 text-cyan-600 transition duration-150 ease-in-out dark:bg-gray-700 dark:border-gray-600"
          />
          <label
            for="remember_me"
            class="ml-2 block text-sm leading-5 text-gray-900 dark:text-gray-300"
          >
            Remember me
          </label>
        </div>

        <div class="text-sm leading-5">
          <router-link :to="{ name: 'forgot' }" class="link">
            Forgot your password?
          </router-link>
        </div>
      </div>

      <div class="md:flex md:justify-center">
        <button
          type="submit"
          class="btn w-full my-1 md:w-1/2 md:mx-2"
          :disabled="!email || !password"
        >
          Sign in
        </button>

        <button
          type="button"
          class="w-full shadow border border-primary my-1 md:w-1/2 md:mx-2 focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:ring-opacity-50 text-primary dark:text-cyan-400 dark:border-cyan-400 dark:hover:bg-gray-700 font-bold py-2 px-4 rounded"
          @click.prevent="() => $router.push({ name: 'register' })"
        >
          Register
        </button>
      </div>
      <social-logins />
    </form>
  </div>
</template>

<script>
import SocialLogins from "@/components/SocialLogins.vue";
import { firebaseAuth } from "@/services/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
export default {
  components: {
    SocialLogins,
  },
  data() {
    return {
      email: "",
      password: "",
    };
  },
  created() {
    // If user is already authenticated, redirect to overview
    if (this.$store.getters.isAuthenticated) {
      this.$router.replace({ name: "overview" });
    }
  },
  methods: {
    async signInWithEmailAndPassword() {
      try {
        await signInWithEmailAndPassword(
          firebaseAuth,
          this.email,
          this.password,
        );
        this.$router.push({ name: "overview" });
      } catch (error) {
        alert(error.message);
      }
    },
  },
};
</script>

<style></style>
